var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col-lg-10 col-md-8 col-12 main"},[_c('img',{staticClass:"banner",attrs:{"src":require("@/assets/img/home/1.jpg")}})])
}]

export { render, staticRenderFns }